import { get, post } from '../../../helpers/api'
import { api } from '../api'
import {
  SET_MEMBER_WALLET_DATA,
  SET_QUEUE_REQUEST_RESPONSE,
  SET_WALLET_ADJUSTMENT_LIST,
  SET_WALLET_GIRO_PAYMENT_LIST,
  SET_WALLET_GIRO_REJECTED_PAYMENT_LIST,
  SHOW_NOTIFICATION,
} from '../../../store/types'

export const getWalletAdjustmentListAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.walletAdjustmentList, query).then(response => {
      const json = response.data.data
      commit(SET_WALLET_ADJUSTMENT_LIST, {
        list: {
          data: json,
          total: response.data.total,
        },
      })
      resolve(response.data)
    })
  })
}

export const createWalletAdjustmentAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.createWalletAdjustment, query).then(response => {
      resolve(response.data)
    })
  })
}

export const loadExistingWalletAdjustmentAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.loadWalletAdjustment, query).then(response => {
      resolve(response.data)
    })
  })
}

export const loadGiroPaymentHistoryAction = ({ commit }, query) => {
  return new Promise((resolve, reject) => {
    post(api.giroPaymentHistory, query)
      .then(response => {
        const json = response.data
        commit(SET_WALLET_GIRO_PAYMENT_LIST, {
          list: {
            data: json.data,
            total: json.total,
          },
        })

        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const retrieveGiroPaymentDetailAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.giroPaymentDetail, query).then(response => {
      commit(SET_QUEUE_REQUEST_RESPONSE, response.data)
      resolve(response.data)
    })
  })
}

export const generateGiroPaymentBatchAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.giroPaymentGenerate, query).then(response => {
      commit(SET_QUEUE_REQUEST_RESPONSE, response.data)
      resolve(response.data)
    })
  })
}

export const getGiroRejectedPaymentListAction = ({ commit }, query) => {
  return new Promise((resolve, reject) => {
    post(api.giroRejectedPaymentList, query)
      .then(response => {
        const json = response.data.data
        commit(SET_WALLET_GIRO_REJECTED_PAYMENT_LIST, {
          list: {
            data: json,
            total: response.data.total,
          },
        })
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const submitGiroRejectedPaymentAction = ({ commit }, query) => {
  return new Promise((resolve, reject) => {
    post(api.giroRejectedPaymentSubmit, query)
      .then(response => {
        commit(SHOW_NOTIFICATION, {
          title: 'GIRO Payment Generation Success',
          message: 'GIRO payment batch generated',
          type: 'positive',
        })
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const submitGiroRejectedLevelOneAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.submitGiroRejectedLevelOne, query).then(response => {
      resolve(response.data)
    })
  })
}

export const submitGiroRejectedLevelTwoAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.submitGiroRejectedLevelTwo, query).then(response => {
      resolve(response.data)
    })
  })
}

export const retrieveGiroRejectedTemplateFileAction = ({ commit }, query) => {
  return new Promise(resolve => {
    get(api.getGiroRejectedTemplate, query).then(response => {
      resolve(response.data)
    })
  })
}

export const createWalletTransactionAction = ({ commit }, query) => {
  return new Promise((resolve, reject) => {
    post(api.eWalletNewTransaction, query)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const getTransactionById = ({ commit }, id) => {
  return new Promise((resolve, reject) => {
    get(`${api.eWalletTransaction}/${id}`)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const getEwalletByPinAction = ({ commit }, query) => {
  return new Promise((resolve, reject) => {
    post(api.eWalletSearchByPin, query)
      .then(response => {
        commit(SET_MEMBER_WALLET_DATA, response.data)
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const getEwalletMobileConfig = ({ commit, dispatch }, data) => {
  return new Promise((resolve, reject) => {
    post(api.eWalletMobileConfig, data)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}
